<script>
/**
 * 作業登録モーダル
 */
import { mapActions } from 'vuex'
import InstructionHistoryModal from "@/driver/pages/driver_schedules/modals/InstructionHistoryModal.vue"

export default {
  name: "InstructionModal",
  components: {
    InstructionHistoryModal,
  },
  props: {
    enableDialog: {
      type: Boolean,
      default: false,
    },
    targetDate: {
      type: String,
      default: null,
    },
    targetDriverId: {
      type: Number,
      default: null,
    },
    choseScheduleId: {
      type: Number,
      default: null,
    },
  },
  watch: {
    enableDialog (newValue) {
      this.$nextTick(() => this.$refs.observer.reset())
      Object.assign(this.$data.forms, this.$options.data().forms);
      if (newValue) {
        this.setVariable()
      }
    },
  },
  data() {
    return {
      forms: {
        id: null,
        task_type: "instruction",
        title: null,
        content: null,
        sort_priority: null,
      },
      enableHistoryModal: false,
    }
  },
  methods: {
    ...mapActions('DriverScheduleInstruction', {
      editInstruction: 'edit',
      createInstruction: 'create',
      updateInstruction: 'update',
    }),
    /**
     * 閉じるボタン　クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    /**
     * 履歴ボタン　クリックイベント
     */
    enableHistoryButtonClickEvent () {
      this.enableHistoryModal = true;
    },
    closeCallback() {
      this.enableHistoryModal = false;
    },
    reflectionHistoryCallback (item) {
      this.forms.title = item.title
      this.forms.content = item.content
      this.closeCallback();
    },
    /**
     * 登録ボタン　クリックイベント
     */
    registerButtonClickEvent () {
      const $self = this
      this.$refs.observer.validate().then((result) => {
        if(result){
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation() {
      const params = {
        title: this.forms.title,
        content: this.forms.content,
        target_date: this.targetDate,
        driver_id: this.targetDriverId,
      }

      if (this.choseScheduleId) {
        this.updateInstruction({ driver_id: this.targetDriverId, id: this.choseScheduleId, params: params }).then((content) => {
          this.$emit('registerCallback', this.targetDriverId, content)
        })
      } else {
        this.createInstruction({ params: params }).then((content) => {
          this.$emit('registerCallback', this.targetDriverId, content)
        })
      }
    },
    /**
     * 初期データセット
     */
    setVariable () {
      if (this.choseScheduleId) {
        this.editInstruction({ driver_id: this.targetDriverId, id: this.choseScheduleId }).then((content) => {
          this.forms = content
        })
      // } else {
      //   console.log('asdsa')
        //   this.newInstruction({ driver_id: this.targetDriverId }).then((content) => {
        //     this.forms = content
        // })
      }
    }
  }
}
</script>

<template>
  <div>
    <v-dialog
      :value="enableDialog"
      width="600"
      @click:outside="closeButtonClickEvent"
      @keydown.esc="closeButtonClickEvent"
      @close="closeButtonClickEvent"
    >
      <validation-observer ref="observer">
        <v-card>
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>作業登録</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <validation-provider
                  v-slot="{ errors }"
                  class="requiredMark"
                  name="タイトル"
                  rules="required|max: 30"
                >
                  <v-text-field
                    v-model="forms.title"
                    :error-messages="errors"
                    dense
                    label="タイトル"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>タイトル</span>
                      <span class="ml-1">
                        ({{ forms.title?.length || 0 }} / 30)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  class="requiredMark"
                  name="内容"
                  rules="required|max:300"
                >
                  <v-textarea
                    v-model="forms.content"
                    :error-messages="errors"
                    dense
                    label="内容"
                    no-resize
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>内容</span>
                      <span class="ml-1">
                        ({{ forms.content?.length || 0 }} / 300)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-textarea>
                </validation-provider>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-btn
              color="info"
              @click="enableHistoryButtonClickEvent"
            >
              入力履歴
            </v-btn>
            <v-spacer />
            <v-btn
              @click="closeButtonClickEvent"
            >
              閉じる
            </v-btn>
            <v-btn
              color="primary"
              @click="registerButtonClickEvent"
            >
              {{ choseScheduleId ? '更新' : '登録' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </validation-observer>
    </v-dialog>

    <instruction-history-modal
      :enable-dialog="enableHistoryModal"
      @closeEvent="closeCallback"
      @reflectionEvent="reflectionHistoryCallback"
    />
  </div>
</template>

<style scoped lang="scss">

</style>
